import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../services/api';

export const fetchExchanges = createAsyncThunk(
  'exchanges/fetchExchanges',
  async () => {
    const response = await api.get('/api/exchanges/');
    
    // Handle paginated response (DRF pagination)
    if (response.data && response.data.results && Array.isArray(response.data.results)) {
      return response.data.results;
    }
    
    // Handle non-paginated response (fallback)
    if (Array.isArray(response.data)) {
      return response.data;
    }
    
    // If unexpected format, return empty array to prevent crashes
    console.error('Unexpected response format from /api/exchanges/:', response.data);
    return [];
  }
);

export const createExchange = createAsyncThunk(
  'exchanges/createExchange',
  async (exchangeData) => {
    const response = await api.post('/api/exchanges/', exchangeData);
    return response.data;
  }
);

export const updateExchange = createAsyncThunk(
  'exchanges/updateExchange',
  async ({ id, data }) => {
    const response = await api.patch(`/api/exchanges/${id}/`, data);
    return response.data;
  }
);

export const deleteExchange = createAsyncThunk(
  'exchanges/deleteExchange',
  async (id) => {
    await api.delete(`/api/exchanges/${id}/`);
    return id;
  }
);

const exchangesSlice = createSlice({
  name: 'exchanges',
  initialState: {
    exchanges: [],
    loading: false,
    error: null,
  },
  reducers: {
    toggleExchangeActive: (state, action) => {
      const exchange = state.exchanges.find((ex) => ex.id === action.payload);
      if (exchange) {
        exchange.is_active = !exchange.is_active;
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchExchanges.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchExchanges.fulfilled, (state, action) => {
        state.loading = false;
        state.exchanges = action.payload;
      })
      .addCase(fetchExchanges.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(createExchange.fulfilled, (state, action) => {
        state.exchanges.push(action.payload);
      })
      .addCase(updateExchange.fulfilled, (state, action) => {
        const index = state.exchanges.findIndex(
          (ex) => ex.id === action.payload.id
        );
        if (index !== -1) {
          state.exchanges[index] = action.payload;
        }
      })
      .addCase(deleteExchange.fulfilled, (state, action) => {
        state.exchanges = state.exchanges.filter(ex => ex.id !== action.payload);
      });
  },
});

export const { toggleExchangeActive } = exchangesSlice.actions;
export default exchangesSlice.reducer;